import React from 'react';
import Modal from '~components/atoms/Modal';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import ProductSettingDetailsForm from '../ProductSettingDetailsForm';

const ProductSettingDeleteProductModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.setting.modals.productSettingDeleteProductModalIsOpen);

    const handleModalOnClose = () => {
        dispatch(combinedActions.settingSetProductSettingDeleteProductModalIsOpen(false));
    };

    return (
        <Modal
            title='Delete Product'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <ProductSettingDetailsForm />
        </Modal>
    );
};

export default ProductSettingDeleteProductModal;
